/**
 ################################
 * Component geeg_slider
 * Built with Maciste / Version 2.0
 ################################
 */

'use strict';
import 'slick-carousel';
//import ScrollMagic from 'scrollmagic';


jQuery(document).ready(function ($) {
    var $mainCarousel = jQuery('.geeg_slider_init');
    var $counter = jQuery('.slider__counter');
    var $prevTh = '';
    $counter.find('.carousel-counter__last').text($mainCarousel.children(':not(.slick-cloned)').length);
    $counter.find('.carousel-counter__current').text($mainCarousel.find('.slick-track').children(':not(.slick-cloned)').index($mainCarousel.find('.slick-slide.slick-active').first()) + 1);

    var $current = jQuery('.slick-active').first();
    var $curTh = $current.find('.slide__content').data('uicolor');
    var active = jQuery('.slick-current').find('.slide__content').data('uicolor')


    jQuery('body').addClass($curTh);
    $prevTh = $curTh;

    $mainCarousel.slick({
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: false,

        responsive: [
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    dots: true,

                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]

    })

    $counter.find('.carousel-counter__current').text('1');
    console.log(jQuery('.slick-current').find('.slide__content').data('uicolor'));
    if (jQuery('.slick-current').find('.slide__content').data('uicolor') == 'dark') {
        jQuery('.geeg_navbar .navbar').addClass('navbar-dark');
        jQuery('.geeg_logo_dark').addClass('d-none');
        jQuery('.geeg_logo_light').addClass('d-block');


    }
    if (jQuery('.slick-current').find('.slide__content').data('uicolor') == 'light') {
        jQuery('.geeg_navbar .navbar').addClass('navbar-light')
        jQuery('.geeg_logo_light').addClass('d-none');
        jQuery('.geeg_logo_dark').addClass('d-block');

    }

// eslint-disable-next-line no-unused-vars


// eslint-disable-next-line no-unused-vars
    $mainCarousel.on('init afterChange', function (event, slick, direction) {
        var $this = jQuery(this);
        var $current = $this.find('.slick-slide.slick-active').first();
        var $sNo = $this.find('.slick-track').children(':not(.slick-cloned)').index($current) + 1;
        var $curTh = $current.find('.slide__content').data('uicolor');
        console.log(jQuery('.slick-current').find('.slide__content').data('uicolor'));

        $counter.find('.carousel-counter__current').text($sNo);

        jQuery('body').removeClass($prevTh);
        jQuery('body').addClass($curTh);
        jQuery('body').removeClass('slide-ui-' + $prevTh);
        jQuery('body').addClass('slide-ui-' + $prevTh);

        jQuery('.geeg_navbar.geeg_navbar--naked_dark .navbar').removeClass('navbar-light navbar-dark').removeClass($prevTh)
        jQuery('.geeg_navbar.geeg_navbar--naked_dark .navbar').addClass('navbar-' + $curTh)
        jQuery('.geeg_navbar.geeg_navbar--naked_light .navbar').removeClass('navbar-light navbar-dark').removeClass($prevTh)
        jQuery('.geeg_navbar.geeg_navbar--naked_light .navbar').addClass('navbar-' + $curTh)

        if (jQuery('.slick-current').find('.slide__content').data('uicolor') == 'dark') {
            jQuery('.geeg_logo_dark').addClass('d-none');
            jQuery('.geeg_logo_dark').removeClass('d-block');

            jQuery('.geeg_logo_light').addClass('d-block');


        }
        if (jQuery('.slick-current').find('.slide__content').data('uicolor') == 'light') {
            jQuery('.geeg_logo_light').addClass('d-none');
            jQuery('.geeg_logo_light').removeClass('d-block');
            jQuery('.geeg_logo_dark').addClass('d-block');

        }

        $prevTh = $curTh;


    });

    /*
        $('.img-parallax').each(function () {
            var img = $(this);
            var imgParent = $(this).parent();

            function parallaxImg() {
                var speed = img.data('speed');
                var imgY = imgParent.offset().top;
                var winY = $(this).scrollTop();
                var winH = $(this).height();
                var parentH = imgParent.innerHeight();


                // The next pixel to show on screen
                var winBottom = winY + winH;

                // If block is shown on screen
                if (winBottom > imgY && winY < imgY + parentH) {
                    // Number of pixels shown after block appear
                    var imgBottom = ((winBottom - imgY) * speed);
                    // Max number of pixels until block disappear
                    var imgTop = winH + parentH;
                    // Porcentage between start showing until disappearing
                    var imgPercent = ((imgBottom / imgTop) * 100) + (50 - (speed * 50));
                }
                img.css({
                    top: imgPercent + '%',
                    transform: 'translate(-50%, -' + imgPercent + '%)'
                });
            }

            $(document).on({
                scroll: function () {
                    parallaxImg();
                }, ready: function () {
                    parallaxImg();
                }
            });


    });
   */

});


/*
  var n = $( '<div class="slick-slide">' ).length;

  console.log(n);
  var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: 'onEnter', duration: '200%'}});

  new ScrollMagic.Scene({triggerElement: '#parallax1'})

    .setTween('#parallax1 > div', {y: '80%'})
    .addIndicators()
    .addTo(controller);
*/

